import { render, staticRenderFns } from "./UndoForm.vue?vue&type=template&id=c9f742fa&scoped=true&"
import script from "./UndoForm.vue?vue&type=script&lang=ts&"
export * from "./UndoForm.vue?vue&type=script&lang=ts&"
import style0 from "./UndoForm.vue?vue&type=style&index=0&id=c9f742fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f742fa",
  null
  
)

export default component.exports